// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZChJ","label":"styles_label__1fzrQ"};